import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
//

import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
//import Style from 'ol/style/Style';
import { Fill, Stroke, Style, Text } from 'ol/style';
import  IconAnchorUnits  from 'ol/style/IconAnchorUnits';
import GeoJSON from 'ol/format/GeoJSON';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import * as olProj from 'ol/proj';
//import TileLayer from 'ol/layer/Tile';

import ImageWMS from 'ol/source/ImageWMS';
import XYZ from 'ol/source/XYZ';
import Overlay from 'ol/Overlay';
import { Group as LayerGroup, Image as ImageLayer, Tile as TileLayer } from 'ol/layer';
import { Coordinate,toStringHDMS } from 'ol/coordinate';
import { Lote } from '../models/Lote';
import { element } from 'protractor';
import { FichaInmaterial, PuntoFichaInmaterial } from './FichaInmaterial';
import { URL_GEOSERVER } from '../global/config';
import { FichaInmaterialService } from '../services/ficha-inmaterial.service';
import { CatFichaInmaterial } from '../models/CatFichaInmaterial';

declare const $: any;

//------------------------------------------------------------------------------------
//-------MODAL CONTENT----------------------------------------------------------------
//------------------------------------------------------------------------------------
@Component({
  selector: 'ngbd-modal-content',
  template: `
    <div class="modal-header" *ngIf="ficha">
      <h4 class="modal-title">Hi there!</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Mi nombre es {{user!.nombre}}</p>
      <p>mi edad es de {{user!.edad}} años</p>
      <p>{{ficha.ubicacion_manifestacion}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
    </div>
  `
})

export class NgbdModalContent {
  @Input() user: any
  @Input() ficha: CatFichaInmaterial

  constructor(public activeModal: NgbActiveModal) {}
}
//------------------------------------------------------------------------------------
//-------MODAL CONTENT----------------------------------------------------------------
//------------------------------------------------------------------------------------



@Component({
  selector: 'app-mapa-inmaterial',
  templateUrl: './mapa-inmaterial.component.html',
  styleUrls: ['./mapa-inmaterial.component.css']
})
export class MapaInmaterialComponent implements OnInit {

    //PROPIEDADES------------------------------------------------------------------------------
    map: Map;
    view: View = new View({
      center: olProj.fromLonLat([-71.9774868,-13.5169427]),
      zoom: 15
    });
    overlay: Overlay;
    infoElemento: FichaInmaterial;
    infoElementoPuntos: PuntoFichaInmaterial;
    catFichaInmaterial: CatFichaInmaterial;
    // CONFIG-GEOSERVER-PROVIDER:
    //urlGeoserver: string = 'http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms'; 
    //urlGeoserverOld: string = 'http://localhost:8080/geoserver/gchc.catalogacion/wms'; 
    //urlGeoserver: string = 'http://192.168.1.15:8080/geoserver/gchc.catalogacion/wms';
    urlGeoserver: string = URL_GEOSERVER.UrlGeoserver; 
    urlGeoserverOws: string = URL_GEOSERVER.UrlGeoserverOws;
    inmaterialesWmsSource: ImageWMS = new ImageWMS({
      url: this.urlGeoserver,
      params: {'LAYERS': 'gchc.catalogacion:fichas_patrimonio_inmaterial', 'TILED': true},
      serverType: 'geoserver',
      //transition: 0,
    }); 
    viewTocMap: boolean = true;
    
    //FIN - PROPIEDADES-------------------------------------------------------------------------
    user =  {
      nombre : "Percy",
      edad: 44
    } 
  

  constructor(
    private catFichaInmaterialService: FichaInmaterialService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {

    var popup = document.getElementById('popup');
    var closer = document.getElementById('popup-closer');
     

    
    //---------------------------------------------------------------
    $(document).ready(function () {
      /// alert('we call alert from JQuery');


      $('#layertree li > span')
        .click(function () {
          $(this).siblings('fieldset').toggle();
        })
        .siblings('fieldset')
        .hide();
    });
    //---------------------------------------------------------------


    this.overlay = new Overlay({
      element: document.getElementById('popup'),
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });

    
    closer.onclick = () => {
      this.overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    this.map = new Map({
      target: 'hotel_map',
      layers: [
        new TileLayer({
          visible:false,
          source: new OSM()
        }),
        
        new TileLayer({
          //title: 'Google Map Hybrid',
          // Again set this layer as a base layer
          //type: 'base',

          visible: true,
          source: new XYZ({
            url: 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}'
          })
        }),
        new LayerGroup({
          layers: [
            new ImageLayer({

              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:borde_acp_gchc', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            new ImageLayer({

              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:borde_gchc', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            new ImageLayer({

              //title: 'Inmebles Relig. Bloques 1er Nivel',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:sectores', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            new ImageLayer({
              //title: 'Sectores',
              visible: false,
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: URL_GEOSERVER_V2,
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: {'LAYERS': 'gchc.catalogacion:lotes', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),/*
            new ImageLayer({
              //title: 'Sectores',
              source: new ImageWMS({
                //url: 'http://172.16.7.144:8080/geoserver/ws_catalogacion_gchc/wms',
                //url: URL_GEOSERVER_V2,
                //url: "http://172.16.7.144:8080/geoserver/gchc.catalogacion/wms",
                url: this.urlGeoserver,
                //params: {'LAYERS': URL_WS_V2+'sectores','STYLES': 'cat_sectores_only_label_sld', 'TILED': true},
                params: {'LAYERS': 'gchc.catalogacion:fichas_patrimonio_inmaterial', 'TILED': true},
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              })
            }),*/
            new VectorLayer({
              source: new VectorSource({
                //format: new GeoJSON(),
                //url: 'http://localhost:8080/geoserver/gchc.catalogacion/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=gchc.catalogacion%3Apuntos_ficha_inmaterial&maxFeatures=50&outputFormat=application%2Fjson',
                
                url: this.urlGeoserverOws+'service=WFS&version=1.0.0&request=GetFeature&typeName=gchc.catalogacion%3Apuntos_ficha_inmaterial&maxFeatures=50&outputFormat=application%2Fjson',
                format: new GeoJSON({
                  //dataProjection: 'EPSG:32719',
                  featureProjection: 'EPSG:4326',
                  
                })
              }),
              style: new Style({
                image: new Icon({
                  anchor: [0.5, 46],
                  anchorXUnits: IconAnchorUnits.FRACTION,
                  anchorYUnits: IconAnchorUnits.PIXELS,
                  src: 'assets/img/inma_icon_7.png'
                })
              })
            }),
            new ImageLayer({
              //title: 'Inmebles Relig. Bloques 1er Nivel',
              visible: true,
              source: new ImageWMS({
                url: this.urlGeoserver,
                params: { 'LAYERS': 'gchc.catalogacion:sectores', 'STYLES': 'cat_sectores_only_label_sld', 'TILED': true },
                serverType: 'geoserver',
                // Countries have transparency, so do not fade tiles:
                //transition: 0,
              }),
            }),
            /*
            new VectorLayer({
              source: new VectorSource({
                url: 'http://localhost:8080/geoserver/gchc.catalogacion/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=gchc.catalogacion%3Ainn&maxFeatures=50&outputFormat=application%2Fjson',
                format: new GeoJSON({
                  //dataProjection: 'EPSG:32718',
                  featureProjection: 'EPSG:4326',
                  //defaultDataProjection: 'EPSG:4326'
                })
              }),
              style: new Style({
                image: new Icon({
                  anchor: [0.5, 46],
                  anchorXUnits: IconAnchorUnits.FRACTION,
                  anchorYUnits: IconAnchorUnits.PIXELS,
                  src: 'http://openlayers.org/en/latest/examples/data/icon.png'
                })
              })
            })*/
          ]

        }),
        
      ],
      view: this.view,
      overlays: [this.overlay]
    });

    //--------------------------------------------------------------------------------------------------
    // Implementación del Layer Group ------------------------------------------------------------------
    //--------------------------------------------------------------------------------------------------
    function bindInputs(layerid, layer) {
      var visibilityInput = $(layerid + ' input.visible');
      visibilityInput.on('change', function () {
        layer.setVisible(this.checked);
      });
      visibilityInput.prop('checked', layer.getVisible());

      var opacityInput = $(layerid + ' input.opacity');
      opacityInput.on('input', function () {
        layer.setOpacity(parseFloat(this.value));
      });
      opacityInput.val(String(layer.getOpacity()));
    };

    function setup(id, group) {
      group.getLayers().forEach(function (layer, i) {
        var layerid = id + i;
        bindInputs(layerid, layer);
        if (layer instanceof LayerGroup) {
          setup(layerid, layer);
        }
      });
    }
    setup('#layer', this.map.getLayerGroup());

    

    //--------------------------------------------------------------------------------------------------
    // END - Implementación del Layer Group ------------------------------------------------------------
    //--------------------------------------------------------------------------------------------------

    //----------------------------------------------------------------------------------------
    this.map.on('click', (e) => {

      /*  METODO 1 ---------------------------------------------------------------------*/

      //var info = [];
      const coordinate = e.coordinate;
      this.map.forEachFeatureAtPixel(e.pixel,  (feature: any) => {
        console.log('INFO PURA', feature.values_.nombre_manifestacion)
        //console.log('INFO PURA', feature.values_.nombre_manifestacion)
        
        this.infoElementoPuntos = { 
          codregistro:feature.values_.codregistro, 
          nombre_manifestacion:feature.values_.nombre_manifestacion
        };
        //this.infoElementoPuntos.nombre_manifestacion = feature.values_.nombre_manifestacion;
        this.overlay.setPosition(coordinate)
        /*
        info.push('<table class="marker-properties"><tbody>' + feature.getKeys().slice(1).map((k, i) => {
          
          return '<tr><th>' + k + '</th>'
          + '<td>' + feature.get(k) + '</td>' + '</tr>';

        }).join('') + '</tbody></table>');*/
        
      });

      
/*
      if (info.length > 0) {
        // console.log(info);
        popup.innerHTML = info.join(',').replace(/<img[^>]*>/g,"");
        popup.style.display = 'inline';
        this.overlay.setPosition(coordinate);
      } else {
        popup.innerHTML = '&nbsp;';
        popup.style.display = 'none';
      }
      */

      /* METODO 2 okkkkkkkkkk------------------------------------------------------- */

      /*
      
      document.getElementById('info').innerHTML = '';
      var coordinate = e.coordinate;
      */
      
      //var viewResolution =  /** @type {number} */ 
      /*
        (this.view.getResolution());
      var url = this.inmaterialesWmsSource.getFeatureInfoUrl(
        e.coordinate,
        viewResolution,
        'EPSG:3857',
        {'INFO_FORMAT': 'application/json'},
      );
      if (url) {
        fetch(url)
          .then( (response) => { return response.text(); })
          .then( (html) => {
            document.getElementById('info').innerHTML = html;

            var info_ficha = JSON.parse(html);
            this.infoElemento = info_ficha.features[0].properties;

            this.overlay.setPosition(coordinate)
          });
      }

      */

  });
  }


  // funciones del Componente-------------
  verFicha(id: string){
    alert(id)
  }

  cargarCatFichaInmaterialPorCodregistro(codregistro: string){

    //------
    

    this.catFichaInmaterialService.traerFichaInmaterialPorCodregistro(codregistro).subscribe(ficha => {
     this.catFichaInmaterial = ficha;
     //creando una instancia del Componente "ModalContent"
     const modalRef = this.modalService.open(NgbdModalContent);
     //asignando el valor del Objeto "ficha" al @Input de la Instancia 
     modalRef.componentInstance.ficha = ficha;
     modalRef.componentInstance.user = this.user;
     //opcional
     console.log(ficha);
    })
  }

  toggleTocMap(){
    if(this.viewTocMap){
      this.viewTocMap = false
    } else{
      this.viewTocMap = true
    }
  }

  //--------------------------------------------------
  open() {
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.user = this.user;
    
  }

}
